<template>
  <div class="container">
    <div class="left">
      <div class="menu">
        <div @click="go(`/user/base-info`)">
          <span>基本信息</span>
        </div>
        <div @click="go(`/user/safe/list`)">
          <span>安全中心</span>
        </div>
        <div class="active">
          <span>设置默认企业</span>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="sub-page">
        <div class="sub-page-title">
          设置默认企业
        </div>
        <div
          class="sub-page-item"
          v-for="(item,index) in corporationList"
          :key="index">
          <div class="sub-page-item-title">
            <span class="main">{{ item.corpName }}</span>
          </div>
          <Button
            v-if="item.primaryCorp"
            type="text"
            class="current">
            默认企业
          </Button>
          <Button
            v-else
            type="text"
            @click="submit(item)">
            设置为默认企业
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {setDefaultCorp} from '@/service';
export default {
  name: 'UserInfo',
  data() {
    return {
      form: this.$store.state.user.user,
    };
  },
  computed: {
    corporationList() {
      return this.$store.state.user.corporationList;
    },
    currentCorp() {
      return this.$store.state.user.currentCorp;
    },
  },
  methods: {
    go(path) {
      this.$router.push(path);
    },
    submit(item) {
      setDefaultCorp(item).then(({resultDesc}) => {
        this.$Message.success(resultDesc);
        this.$store.dispatch('user/init');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-page {
  flex: 1;
  &-title {
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 20px;
  }
  &-item {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f4f4f4;
    &-title {
      display: flex;
      flex-direction: column;
      .main {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.85);
      }
      .sub {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
      }
    }
    .ivu-btn {
      font-size: 12px;
      color: #1890ff;
      &.current {
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
}
</style>
